import type { SbBlokData } from "@storyblok/react";
import { storyblokEditable } from "@storyblok/react";
import config from "config/config";
import {
  APRCards,
  AboutUsTrustpilotSection,
  AboveTheFoldAutocompleteSection,
  AboveTheFoldCTASection,
  Accordion,
  AhPlusModal,
  AhPlusPricingPlans,
  AhTimeline,
  AirHelpPlusBenefitsSection,
  Aligner,
  Anchor,
  BlogLegacyContent,
  Button,
  CTA,
  Cards,
  CheckList,
  Collapsible,
  Column,
  ComparisonCards,
  CompensationFeeCards,
  ContainerWithHeaderSection,
  Content,
  ContentWithImageSection,
  ErrorComponent,
  FeeModelCards,
  Flags,
  Footer,
  Heading,
  HelpQuestion,
  HeroForm,
  HeroImageSection,
  HorizontalDivider,
  Icon,
  Image,
  ImageCTA,
  InfoBox,
  LegalContent,
  Link,
  LinkBox,
  ListCard,
  Logo,
  Modal,
  OneTrustCookiesList,
  OurFeesCompensationTable,
  OurTeamSection,
  PartnerCards,
  PartnersHero,
  PieChart,
  Popover,
  PressCoverageItem,
  Row,
  Schema,
  SectionHeader,
  SideBarHeading,
  Spacer,
  Subscribe,
  Table,
  TestimonialsSection,
  TextSwitcher,
  Trustpilot,
  TrustpilotExtended,
  TrustpilotReviewCard,
  TrustpilotSlider,
  TrustpilotTestimonial,
  UnstyledListWithIcon,
  Unsubscribe,
  WhyChooseAirHelp,
  WhyChooseAirHelpSection,
  Header,
  HowItWorks,
  CTABar,
  OpenChatButton,
  OneTrustSettingsButton,
} from "../adapters";

const developmentEnvironment = config.buildEnv === "development";

// resolve Storyblok components to Next.js components
const Components = {
  sideBarHeading: SideBarHeading,
  heading: Heading,
  content: Content,
  ctaSection: CTA,
  ctaImageSection: ImageCTA,
  legalContent: LegalContent,
  blogLegacyContent: BlogLegacyContent,
  image: Image,
  row: Row,
  column: Column,
  link: Link,
  linkBox: LinkBox,
  infoBox: InfoBox,
  checkList: CheckList,
  table: Table,
  subscribe: Subscribe,
  cards: Cards,
  button: Button,
  trustpilotReview: TrustpilotReviewCard,
  trustpilot: Trustpilot,
  anchor: Anchor,
  logo: Logo,
  flags: Flags,
  heroForm: HeroForm,
  trustpilotSlider: TrustpilotSlider,
  accordion: Accordion,
  helpQuestion: HelpQuestion,
  whyChooseAirHelp: WhyChooseAirHelp,
  spacer: Spacer,
  schema: Schema,
  comparisonCards: ComparisonCards,
  pieChart: PieChart,
  icon: Icon,
  textSwitcher: TextSwitcher,
  ahPlusPricingPlans: AhPlusPricingPlans,
  compensationFeeCards: CompensationFeeCards,
  feeModelCards: FeeModelCards,
  aboveTheFoldCTASection: AboveTheFoldCTASection,
  trustpilotExtended: TrustpilotExtended,
  aboveTheFoldAutocompleteSection: AboveTheFoldAutocompleteSection,
  testimonialsSection: TestimonialsSection,
  pressCoverageItem: PressCoverageItem,
  contentWithImageSection: ContentWithImageSection,
  listCard: ListCard,
  heroImageSection: HeroImageSection,
  partnerCards: PartnerCards,
  partnersHero: PartnersHero,
  ourFeesCompensationTable: OurFeesCompensationTable,
  trustpilotTestimonial: TrustpilotTestimonial,
  ourTeamSection: OurTeamSection,
  aboutUsTrustpilotSection: AboutUsTrustpilotSection,
  collapsible: Collapsible,
  ahTimeline: AhTimeline,
  horizontalDivider: HorizontalDivider,
  popover: Popover,
  unstyledListWithIcon: UnstyledListWithIcon,
  unsubscribe: Unsubscribe,
  modal: Modal,
  ahPlusModal: AhPlusModal,
  airHelpPlusBenefitsSection: AirHelpPlusBenefitsSection,
  aligner: Aligner,
  whyChooseAirHelpSection: WhyChooseAirHelpSection,
  sectionHeader: SectionHeader,
  containerWithHeaderSection: ContainerWithHeaderSection,
  aPRCards: APRCards,
  footer: Footer,
  oneTrustCookiesList: OneTrustCookiesList,
  header: Header,
  howItWorks: HowItWorks,
  ctaBar: CTABar,
  openChatButton: OpenChatButton,
  oneTrustSettingsButton: OneTrustSettingsButton,
};

const DynamicComponent = (props: { blok: SbBlokData; extraParams?: Record<string, unknown> }) => {
  const { blok, extraParams } = props;
  const Component = Components[blok.component] || (developmentEnvironment && ErrorComponent);
  if (!Component) return null;

  const sbEditable = storyblokEditable(blok);

  return <Component blok={blok} sbEditable={sbEditable} extraParams={extraParams} />;
};

export default DynamicComponent;
